var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551.6,587.4h-27.3v-45.5c0-5-4.1-9.1-9.1-9.1H488V323.7h36.4c5,0,9.1-4.1,9.1-9.1v-54.5c0-5-4.1-9.1-9.1-9.1 h-27.3v-36.4c0-3.9-2.4-7.3-6.1-8.6l-181.8-63.6c-1.9-0.7-4.1-0.7-6,0L121.4,206c-3.6,1.3-6.1,4.7-6.1,8.6V251H88 c-5,0-9.1,4.1-9.1,9.1v54.5c0,5,4.1,9.1,9.1,9.1h36.4v209.1H97.1c-5,0-9.1,4.1-9.1,9.1v45.5H60.7c-5,0-9.1,4.1-9.1,9.1v45.5 c0,5,4.1,9.1,9.1,9.1h490.9c5,0,9.1-4.1,9.1-9.1v-45.5C560.7,591.4,556.7,587.4,551.6,587.4z M469.8,532.8h-54.5V323.7h54.5V532.8z  M351.6,532.8V323.7h45.5v209.1H351.6z M215.3,532.8V323.7h45.5v209.1H215.3z M278.9,323.7h54.5v209.1h-54.5V323.7z M133.5,221.1 l172.7-60.5l172.7,60.5V251H133.5V221.1z M97.1,269.2c30.4,0,387.7,0,418.2,0v36.4c-136.2,0-282,0-418.2,0V269.2z M142.6,323.7h54.5 v209.1h-54.5V323.7z M106.2,551c129.9,0,270.1,0,400,0v36.4h-400V551z M542.6,632.8H69.8v-27.3c33.9,0,438.8,0,472.7,0V632.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.fbe860dd.svg";
export { ForwardRef as ReactComponent };